"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ShieldCheck, Cpu, Landmark } from "lucide-react";
const pillars = [{
  title: "GOVERNANCE TO IMPLEMENTATION",
  description: "We translate cybersecurity and technology requirements into practical architectures, controls and delivery roadmaps.",
  icon: ShieldCheck
}, {
  title: "INTEGRATED TECHNOLOGY DELIVERY",
  description: "We combine consultancy and system integration capabilities to design, implement and support secure technology solutions.",
  icon: Cpu
}, {
  title: "UAE-FOCUSED EXECUTION",
  description: "We support government and enterprise environments with solutions aligned to operational priorities and applicable regulatory expectations.",
  icon: Landmark
}];
export default function TwentyFiveYearsOfExpertExperience() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="25-years-of-expert-experience" className="bg-background px-6 pt-16 md:pt-20 pb-20 md:pb-24">
      <div className="mx-auto max-w-screen-xl">
        {}
        <div ref={headerRef} className={`mb-16 max-w-3xl transition-all duration-700 ease-out ${headerVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <span className="mb-2 block font-mono text-sm font-semibold tracking-widest text-primary uppercase">
            OUR DELIVERY DIFFERENCE
          </span>
          <h2 className="mt-3 font-default text-3xl font-bold tracking-tight text-foreground md:text-5xl">
            From Strategy to Secure Implementation
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-muted-foreground">
            FETC combines cybersecurity consultancy, technology architecture and system integration capabilities to help organizations move from requirements to practical, secure delivery.
          </p>
        </div>

        {}
        <div className="mt-12 grid grid-cols-1 gap-10 pb-12 md:grid-cols-3 md:pb-16">
          {pillars.map((pillar, index) => <PillarCard key={index} pillar={pillar} index={index} />)}
        </div>
      </div>
    </section>;
}
function PillarCard({
  pillar,
  index
}: {
  pillar: typeof pillars[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const Icon = pillar.icon;
  return <div ref={ref} data-index={index} className={`group relative flex min-h-[320px] flex-col rounded-lg border border-border bg-card p-8 transition-all duration-700 ease-out hover:border-primary/50 md:min-h-[400px] md:p-10 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`} style={{
    transitionDelay: `${index * 150}ms`
  }}>
      <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-md bg-primary/10 text-primary transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
        <Icon size={24} strokeWidth={1.5} />
      </div>
      
      <h3 className="mb-4 font-default text-xl font-semibold tracking-tight text-foreground md:text-2xl">
        {pillar.title}
      </h3>
      
      <p className="text-base leading-relaxed text-muted-foreground md:text-lg">
        {pillar.description}
      </p>
      
      {}
      <div className="absolute top-0 left-0 h-1 w-0 bg-primary transition-all duration-300 group-hover:w-full rounded-t-lg" />
    </div>;
}